import React from "react";

export default function Terms() {
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
      <div className="text-xs uppercase tracking-[0.25em] text-brand-red mb-2">Légal</div>
      <h1 className="font-display text-4xl font-semibold mb-6">Conditions générales d'utilisation</h1>
      <div className="prose prose-neutral max-w-none text-mute space-y-4">
        <p>Bienvenue sur NelDaari. En utilisant notre plateforme, vous acceptez les conditions ci-dessous.</p>
        <h2 className="font-display text-2xl text-ink">1. Service</h2>
        <p>NelDaari est une plateforme de mise en relation entre clients, restaurants et livreurs à Conakry, République de Guinée. Nous facilitons la commande et la livraison de repas mais ne sommes pas le producteur des plats.</p>
        <h2 className="font-display text-2xl text-ink">2. Compte</h2>
        <p>Pour passer commande, vous devez créer un compte en fournissant des informations exactes (nom, email, téléphone, adresse).</p>
        <h2 className="font-display text-2xl text-ink">3. Paiement</h2>
        <p>Nous acceptons : paiement à la livraison, Orange Money, MTN Mobile Money et carte bancaire. Les prix sont affichés en Francs Guinéens (GNF).</p>
        <h2 className="font-display text-2xl text-ink">4. Livraison</h2>
        <p>Les délais affichés sont indicatifs. La couverture concerne les quartiers de Conakry : Kaloum, Dixinn, Ratoma, Matam, Matoto, Kipé, Lambanyi, Nongo, Sonfonia, Cosa, Taouyah.</p>
        <h2 className="font-display text-2xl text-ink">5. Commission</h2>
        <p>NelDaari prélève une commission de 12% sur les ventes des restaurants partenaires pour couvrir les frais de plateforme.</p>
        <h2 className="font-display text-2xl text-ink">6. Données personnelles</h2>
        <p>Vos données sont protégées et utilisées uniquement pour le fonctionnement du service. Vous pouvez nous contacter à tout moment pour les consulter ou les supprimer.</p>
      </div>
    </div>
  );
}
